import { ComponentAdapter } from "@omegagrid/core";
import { FormulaEditor } from "./formulaEditor";

export type FormulaEditorOptions = {
	closeAfterSave?: boolean,
	toolbar?: boolean,
	variablesGrid?: boolean
}

export type VariableSource = {
	variable: string,
	description?: string,
}

export const DEFAULT_FORMULA_EDITOR_OPTIONS: FormulaEditorOptions = {
	closeAfterSave: true,
	toolbar: true,
	variablesGrid: false
}

export abstract class FormulaEditorAdapter<TEditor extends FormulaEditor> extends ComponentAdapter<TEditor>{
	public editor: FormulaEditor;
	abstract getVariables(): null|VariableSource[]|Promise<VariableSource[]>;
	async getContent(): Promise<string> { return '' }
	async save(formula?: string): Promise<void|string> { }
	getOptions(): null|Partial<FormulaEditorOptions>|Promise<Partial<FormulaEditorOptions>> { return DEFAULT_FORMULA_EDITOR_OPTIONS }
	createOptions(options: Partial<FormulaEditorOptions>): FormulaEditorOptions {
		return Object.assign({}, DEFAULT_FORMULA_EDITOR_OPTIONS, options);
	}
}
